import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import mapSelectorsToProps from '../selectors/mapSelectorsToProps'

import { isAutoPlayEnabled, setLocations, initTour, resetTourData } from 'aria-viewer/tour/tourActions'
import { VIDEO_START_TIME } from 'aria-viewer/tour/constants/queryConstants'
import isEqual from 'lodash-es/isEqual'
import compose from 'recompose/compose'

class AriaViewerRouteHandler extends PureComponent {
    constructor(props) {
        super(props)

        this.locationIsSet = false
        this.currentProps = null
        this.lastTourData = null

        this.state = { loaded: false }
    }

    componentWillMount() {
        this.init(this.props)
    }

    componentWillReceiveProps(nextProps) {
        this.init(nextProps)
    }

    init = props => {
        if (this.currentProps && this.currentProps.getTourID) this.previousTourId = this.currentProps.getTourID.tourid
        this.currentProps = props

        if ('autoplay' in props.location.query) {
            props.isAutoPlayEnabled(true)
            //here
        }

        const location = props.getLocId
        const tour = props.getTourID
        const inst_id = props.match.params.inst_id.toLowerCase()
        const urlDefinedLocId = props.match.params.loc_id ? props.match.params.loc_id.toLowerCase() : false

        /**
         * ////////		TODO    //////////
         * create a helper class to parse out whatever query that will be added
         */
        // this indicates whether the tour is initiated from VR app
        const fromVR = parseInt(props.location.query.fromVR)

        const stopid = props.location.query.stopid
        const loadSingleStopOnly = props.location.query.loadSingleStopOnly
        const videoStartTime = props.location.query[VIDEO_START_TIME]

        /**
         * Set location information used urlDefinedLocId to ensure our analytics data is accurate.
         * Specfically the cache string is related to a location
         */
        this.setLocation(inst_id, urlDefinedLocId)(props.analytics)

        if (location && tour) {
            this.setState({
                loaded: true,
            })

            const loc_id = props.match.params.loc_id ? props.match.params.loc_id.toLowerCase() : location.loc_id
            const { tourid } = tour
            const { owner_id } = location

            this.initializeTour({
                inst_id: owner_id,
                loc_id,
                tourid,
                stopid,
                loadSingleStopOnly,
                fromVR,
                videoStartTime,
                params: props.match.params,
            })
        }
    }

    //ensure we use the interger loc_id for API request.
    findLocation = loc_id => {
        return this.currentProps.locationsList.find(loc => loc.loc_id == loc_id || loc.unique_id == loc_id)
    }

    setLocation = (inst_id, loc_id) => analytics => {
        if (!this.locationIsSet) {
            this.locationIsSet = true
            this.props.setLocations(inst_id, loc_id)(analytics)
        }
    }

    initializeTour = ({ inst_id, loc_id, tourid, stopid, fromVR, loadSingleStopOnly, videoStartTime, params }) => {
        const { loc: loc_query, language, media: media_query } = this.currentProps.location.query
        const { loc_id: numeric_loc_id } = this.findLocation(loc_id)

        const tourData = {
            inst_id,
            loc_id: numeric_loc_id,
            tourid,
            loc_query,
            language,
            stopid,
            fromVR,
            loadSingleStopOnly,
            videoStartTime,
            media_query,
        }

        if (!isEqual(tourData, this.lastTourData)) {
            this.lastTourData = tourData
            this.props.resetTourData()
            //Inject location params which are used later
            this.props.initTour({ ...tourData, params })
        }
    }

    render() {
        const { isExperienceOffline } = this.props
        const { loaded } = this.state

        return <div>{loaded || isExperienceOffline ? this.props.children : null}</div>
    }
}

const mapStateToProps = state => ({
    isExperienceOffline: state.getIn(['tour', 'isExperienceOffline']),
})

export default compose(
    connect(mapStateToProps),
    connect(mapSelectorsToProps(['getLocId', 'getTourID', 'locationsList']), {
        setLocations,
        initTour,
        isAutoPlayEnabled,
        resetTourData,
    })
)(AriaViewerRouteHandler)
